// /utils/answerUtils.js
export function normalizeText(s) {
    if (s == null) return '';
    let out = String(s)
      .normalize('NFKC')
      .replace(/\s+/g, '')
      .toLowerCase();

    // ひらがな → カタカナ
    out = out.replace(/[\u3041-\u3096]/g, ch =>
      String.fromCharCode(ch.charCodeAt(0) + 0x60)
    );

    // 長音など
    out = out.replace(/[ー―−‐-]/g, 'ー');
  
    // 軽い記号除去
    out = out.replace(/[.,/#!$%^&*;:{}=_`~()（）・]/g, '');

    return out;
  }

  export function isCorrectAnswer(userInput, correct) {
    const user = normalizeText(userInput);
    const candidates = Array.isArray(correct)
      ? correct
      : String(correct ?? '').split('|');
    return candidates.some(ans => normalizeText(ans) === user);
  }